
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import Choice from "../lib/Choice";

    @Component({})
    export default class SelectComponent extends Vue {

        @Prop({default: null})
        public default: any;

        @Prop({default: null})
        public question?: any;

        public selected?: any = null;

        @Prop({default: false})
        public required?: boolean;
        @Prop({default: []})
        public options?: any;
        public optionsOpen = false;

        public choose(option: any) {
            this.selectOption(option);
            this.$emit('clicked-option');
        }

        public mounted() {
            if (this.question) {
                // console.log(this.question.options);
                const selected = this.question.options.find((option: Choice) => option.id === this.question.currentResponse!.valueId) || null;
                if (selected) {
                    this.selectOption(selected);
                }
            }
            if (!this.selected && this.default) {
                this.selectOption(this.default);
            }
            if (this.required && !this.selected && this.options.length) {
                this.selectOption(this.options[0]);
            }
        }

        toggleOptions() {
            this.optionsOpen = !this.optionsOpen;
        }

        closeOptions() {
            this.optionsOpen = false;
        }

        openOptions() {
            this.options = true;
        }

        selectOption(option: any) {
            const selected = option === '' ? null : option;
            this.$set(this, 'selected', selected);
            this.$emit('changed', selected);
            this.closeOptions();
        }
    }
